import React from 'react'
import { connect } from 'react-redux'
import termsHtml from '../../res/pdf/terms.htm';
import color from '../../res/color';

const styles = {
    main: {
        width: '90%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        userSelect: "none",
        justifyContent: 'space-around',
        alignSelf: 'center',
        alignItems: 'center',
    },
    buttonBack: {
        width: '20%',
        alignSelf: 'center',
        alignItems: 'center',
        padding: '2%',
        userSelect: "none",
        cursor: 'pointer',
        border: '3px solid' + color.lightBorderColor,
    },
}

type Props = {
};

type State = {
};

class TermsPage extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.containerDiv = React.createRef();
        this.state = {
        };
    }
    componentDidMount() {
        fetch(termsHtml)
            .then(res => res.text())
            .then(text => document.querySelector('#inner').innerHTML = text)
    }

    reloadPage(): Function {
        window.location.reload()
    }

    render() {
        return (
            <div style={styles.main}>
                <div id="inner"></div>
                <button style={styles.buttonBack} onClick={() => this.reloadPage()}>戻る</button>
            </div >
        );
    }
}

TermsPage.defaultProps = {
    isStart: false,
}
const mapStateToProps = state => ({
});

export default connect(mapStateToProps)(TermsPage);